import moment from 'moment';
import DynamicAPI from '../shared/axios';
import { loggedUserRequestErrorHandler } from '../shared/http/error';
import { subMonths } from 'date-fns';
import { periodFilterToDays } from '../pages/Dashboard/components/Filter/RetrofitDateModal';
import { showToastError, showToastSuccess } from '../components/toasty';
import downloadjs from 'downloadjs';

const CHANGE_FILTERS = 'luft/carbon/CHANGE_FILTERS';
const GET_CARBON_EMISSION_LIST = 'luft/carbon/GET_CARBON_EMISSION_LIST';
const GET_CARBON_EMISSION_LIST_SUCCESS = 'luft/carbon/GET_CARBON_EMISSION_LIST_SUCCESS';
const GET_CARBON_EMISSION_LIST_FAILURE = 'luft/carbon/GET_CARBON_EMISSION_LIST_FAILURE';
const EXPORT_CARBON_EXCEL = 'luft/carbon/EXPORT_CARBON_EXCEL';
const EXPORT_CARBON_EXCEL_SUCCESS = 'luft/carbon/EXPORT_CARBON_EXCEL_SUCCESS';
const EXPORT_CARBON_EXCEL_FAILURE = 'luft/carbon/EXPORT_CARBON_EXCEL_FAILURE';

const initialPeriod = subMonths(new Date(), periodFilterToDays.LAST_6_MONTHS);
const finalPeriod = new Date();

const initialState = {
  filters: {
    initialPeriod: initialPeriod.toISOString(),
    finalPeriod: finalPeriod.toISOString(),
    listCompany: [],
    listRegion: [],
    nfType: "0",
    modal: "1",
    listCustomerTMS: [],
    orderBy: [
      { attribute: 'weight', value: 'desc' }
     ],
     page: 1,
     amount: 10
   },
   carbonList: {
    isFetching: false,
    error: '',
    requested: '',
    data: {
      registration: "",
      description: "",
      certificateUrl: "",
      totalKilometersDriven: "",
      totalCarbonEmission: "",
      totalCarbonCredit: "",
      totalCarbonRatio: "",
      totalCarbonRatioStatus: null,
      list: [],
    },
  },
  exportExcel: {
    isFetching: false,
    error: '',
    requested: '',
  }
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_FILTERS: {
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.filters,
        },
      };
    }
    case GET_CARBON_EMISSION_LIST:
      return {
        ...state,
        carbonList: {
          ...state.carbonList,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };
    case GET_CARBON_EMISSION_LIST_SUCCESS:
      return {
        ...state,
        carbonList: {
          ...state.carbonList,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: false,
          error: '',
          data: action.list,
        },
      };

    case GET_CARBON_EMISSION_LIST_FAILURE:
      return {
        ...state,
        carbonList: {
          ...state.carbonList,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: false,
          error: action.error,
        },
      };

    case EXPORT_CARBON_EXCEL:
      return {
        ...state,
        exportExcel: {
          ...state.exportExcel,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case EXPORT_CARBON_EXCEL_SUCCESS:
      return {
        ...state,
        exportExcel: {
          ...state.exportExcel,
          isFetching: false,
          error: '',
        },
      };
      
    case EXPORT_CARBON_EXCEL_FAILURE:
      return {
        ...state,
        exportExcel: {
          ...state.exportExcel,
          isFetching: false,
          error: action.error,
        },
      };

    default:
      return state;
  }
}

export function changeFilters(filters = {}) {
  return {
    type: CHANGE_FILTERS,
    filters,
  };
}

function _getCarbonEmissionList() {
  return {
    type: GET_CARBON_EMISSION_LIST,
  };
}

function _getCarbonEmissionListSuccess(list) {
  return {
    type: GET_CARBON_EMISSION_LIST_SUCCESS,
    list,
  };
}

function _getCarbonEmissionListFailure(error) {
  return {
    type: GET_CARBON_EMISSION_LIST_FAILURE,
    error,
  };
}

function _exportCarbonListExcel() {
  return {
    type: EXPORT_CARBON_EXCEL,
  }
}

function _exportCarbonListExcelSuccess() {
  return {
    type: EXPORT_CARBON_EXCEL_SUCCESS,
  }
}

function _exportCarbonListExcelFailure(error) {
  return {
    type: EXPORT_CARBON_EXCEL_FAILURE,
    error,
  };
}

export function getCarbonEmissionList(overrideFilters = {}) {
  return function (dispatch, getState) {
    (async () => {
      dispatch(_getCarbonEmissionList());
      try {
        const params = { ...getState().carbon.filters, ...overrideFilters };
        const { activeCompanyId } = getState().auth;
        const http = new DynamicAPI('v1');
        const response = await http.post(
          '/CarbonEmission/CarbonEmissionList',
          {
            ...params,
            companyId: activeCompanyId,
          },
        );

        if (!response.data) {
          dispatch(_getCarbonEmissionListFailure('Ops! Não conseguimos carregar as informações'));
        } else {
          dispatch(_getCarbonEmissionListSuccess(response.data));
        }
      } catch (error) {
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          dispatch(_getCarbonEmissionListFailure('Ops! Não conseguimos carregar as informações'))
        );
      }
    })();
  };
}

export function exportCarbonListExcelBase64String() {
  return function (dispatch, getState) {
    (async () => {
      dispatch(_exportCarbonListExcel());
      try {
        const params = getState().carbon.filters;
        const { activeCompanyId } = getState().auth;
        const http = new DynamicAPI('v1');
        const mimeType = 'application/ms-excel';
        const response = await http.post(
          '/CarbonEmission/ExportCarbonListExcelBase64String',
          {
            initialPeriod: params.initialPeriod,
            finalPeriod: params.finalPeriod,
            companyId: activeCompanyId,
            byDate: 1,
          },
        );

        const data = `data:${mimeType};base64,${response.data}`;
        const filename = 'carbon.xlsx';

        showToastSuccess('Exportando lista...');
        downloadjs(data, filename, mimeType);
        dispatch(_exportCarbonListExcelSuccess());
      } catch (error) {
        console.log(error)
        showToastError('Erro ao exportar lista');

        loggedUserRequestErrorHandler(
          dispatch,
          error,
          dispatch(_exportCarbonListExcelFailure(error.message))
        );
      }
    })();
  };
}
